import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import TopNavigation from '../components/TopNavigation';
import { useUserContext } from 'UserContext';
import { BusinessLayout } from 'parent-portal/navigation';
import { AdminLayout } from 'library/ui';
import StakeholderNav from '../internal/sub-pool-stakeholder/StakeholderNav';

export const Private = ({ component: Component, ...rest }) => {
    const { role } = useUserContext();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (localStorage.getItem('token') !== null) {
                    if (
                        props.location.pathname.startsWith('/sub-pool-stakeholder') &&
                        role &&
                        role !== 'sub_pool_stakeholder'
                    ) {
                        return <Redirect to={{ pathname: '/' }} />;
                    }
                    if (role === 'family') {
                        return !props.location.pathname.includes('family') ? (
                            <Redirect
                                to={{
                                    pathname: '/family',
                                }}
                            />
                        ) : (
                            <Component {...props} />
                        );
                    }
                    if (role === 'sub_pool_stakeholder') {
                        if (!props.location.pathname.startsWith('/sub-pool-stakeholder')) {
                            return <Redirect to={{ pathname: '/sub-pool-stakeholder/dashboard' }} />;
                        }
                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                                <StakeholderNav />
                                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                    <Component {...props} />
                                </div>
                            </div>
                        );
                    }
                    if (role && role !== 'admin' && role !== 'sitter' && role !== 'sub_pool_stakeholder') {
                        return (
                            <BusinessLayout>
                                <Component {...props} />
                            </BusinessLayout>
                        );
                    }
                    if (role === 'admin') {
                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                                <TopNavigation />
                                <AdminLayout>
                                    <Component {...props} />
                                </AdminLayout>
                            </div>
                        );
                    }
                    if (role === 'sitter') {
                        return (
                            <>
                                <Component {...props} />
                            </>
                        );
                    }
                    return <></>;
                }

                const pathname = props.location?.pathname?.indexOf('sitter/') > -1 ? '/sitter' : '/';

                return <Redirect to={{ pathname, search: props.location.search, state: { from: props.location } }} />;
            }}
        />
    );
};
